import ATE from "../../../ActionTypeEnum";
import IJobBtcResult from "../interfaces/IJobBtcResult";
import IJobLowRiskResult from "../interfaces/IJobBtcResult";
import {IJobMutationResult} from "../interfaces/IJobMutationResult"

export default {

BtcResults: (data: IJobMutationResult) => ({
    type: ATE.BTC_MUTATION_SUCCESS,
    value: data,
}),
LowRiskResults: (data: IJobMutationResult) => ({
    type: ATE.LOW_RISK_MUTATION_SUCCESS,
    value: data,
}),
HighRiskResults: (data: IJobMutationResult) => ({
    type: ATE.HIGH_RISK_MUTATION_SUCCESS,
    value: data,
}),
CombinedLowRiskResults: (data: IJobMutationResult) => ({
    type: ATE.COMBINED_LOW_RISK_MUTATION_SUCCESS,
    value: data,
}),
CombinedHighRiskResults: (data: IJobMutationResult) => ({
    type: ATE.COMBINED_HIGH_RISK_MUTATION_SUCCESS,
    value: data,
}),
allResidues: (data: IJobMutationResult) => ({
    type: ATE.ALL_RESIDUES_MUTATION_SUCCESS,
    value: data,
}),
ancestralDesigns: (data: IJobMutationResult) => ({
    type: ATE.ANCESTRAL_DESIGNS_SUCCESS,
    value: data,
}),

setTypes: (data: any) => ({
    type: ATE.SET_CALCULATION_TYPES,
    value: data,
}),

setMapping: (data: any) => ({
    type: ATE.SET_CALCULATION_MAPPING,
    value: data,
}),

setResultPDB: (data: any) => ({
    type: ATE.SET_RESULT_PDB,
    value: data
}),

}
